// @ts-nocheck
import React from "react";

const SmartAIButton = ({ isActive, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      title="Smart AI Settings"
      className="smart-ai-button"
      style={{
        position: "relative",
        zIndex: 2,
        background: "none",
        border: "none",
        padding: "8px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        marginRight: "2px",
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="smart-ai-icon"
      >
        <path
          d="M16,25.5c0,1.9,1.6,3.5,3.5,3.5c1.8,0,3.2-1.3,3.5-3c2.8-0.2,5-2.6,5-5.5c0-1.4-0.5-2.6-1.3-3.6 c1.4-1,2.3-2.6,2.3-4.4c0-3-2.5-5.5-5.5-5.5c-0.2,0-0.3,0-0.5,0V6.5C23,4.6,21.4,3,19.5,3S16,4.6,16,6.5"
          stroke={isActive ? "#7B68EE" : "#ADACBF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <path
          d="M16,25.5c0,1.9-1.6,3.5-3.5,3.5c-1.8,0-3.2-1.3-3.5-3c-2.8-0.2-5-2.6-5-5.5c0-1.4,0.5-2.6,1.3-3.6 C3.9,16,3,14.3,3,12.5C3,9.5,5.5,7,8.5,7C8.7,7,8.8,7,9,7V6.5C9,4.6,10.6,3,12.5,3S16,4.6,16,6.5"
          stroke={isActive ? "#7B68EE" : "#ADACBF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <path
          d="M28,21c0-2.1-1.3-3.9-3.2-4.7"
          stroke={isActive ? "#7B68EE" : "#ADACBF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <path
          d="M6.8,17.7C4.6,17,3,14.9,3,12.5"
          stroke={isActive ? "#7B68EE" : "#ADACBF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <path
          d="M10.2,9.2C9.5,8.5,9,7.6,9,6.5"
          stroke={isActive ? "#7B68EE" : "#ADACBF"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
        <polygon
          points="21,15 17,15 19.5,9 11,17 15,17 13,23"
          stroke={isActive ? "#7B68EE" : "#ADACBF"}
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
      </svg>
    </button>
  );
};

export default SmartAIButton;